import { render, staticRenderFns } from "./Handbag.vue?vue&type=template&id=392561ad"
import script from "./Handbag.vue?vue&type=script&lang=js"
export * from "./Handbag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports